import { useEffect, useState, useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import {
  wsPostConfirmaCodigo,
  wsGetCambioClave,
  logoutPacienteDefault,
} from "../../../context/Actions/paciente/paciente";
import { showToaster } from "../../../../global/context/action/toaster/toaster.js";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import Temporizador from "../../Genericos/Temporizador/Temporizador";
import "./CambioPassword.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { IonSpinner } from "@ionic/react";

const CambioPasswordPaso2 = ({ dissmiss, texto }) => {
  const { modalDispatch, registroState, pacienteState, pacienteDispatch } =
    useContext(PortalContext);

  // contexto global del Toaster
  const { toasterDispatch } = useContext(GlobalContext);

  const [disable, setDisable] = useState(false);
  const [codigo, setCodigo] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    document.getElementsByName("codigoSeguridad")[0].focus();
    setDisable(true);
  }, []);

  const reenviarEmail = () => {
    let dni = registroState.registro.usuario.nro_documento;
    wsGetCambioClave(dni, changePaso)(pacienteDispatch);
    setDisable(true);
    showToaster(
      {
        texto: "Enviamos nuevamente el código a su casilla de Email.",
        tipo: "success",
      },
      "centroArriba"
    )(toasterDispatch);
  };

  const onChangeTemporizador = () => {
    setDisable(false);
  };

  const isEmptyError = (empty) => {
    if (empty === "") {
      return true;
    }
    return false;
  };

  const checkCodigo = () => {
    if (codigo !== "") {
      wsPostConfirmaCodigo(codigo, changePaso)(pacienteDispatch);
    } else {
      showToaster(
        {
          texto:
            "El codigo que quiere Validar, es invalido. Por favor, complete el campo correctamente.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const onCodigoChange = (e) => {
    let errx = false;
    errx = isEmptyError(e.target.value);
    setError(errx);
    setCodigo(e.target.value);
  };

  const changePaso = (isCorrect, data) => {
    if (isCorrect) {
      // if (data !== null && data !== undefined && data > 0) {
      hideModal()(modalDispatch);
      showToaster(
        {
          texto: "Código válido",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      showModal(
        "Auth/CambioPassword/CambioPasswordPaso3",
        {
          titulo: "Creá una contraseña nueva",
          token: codigo,
          dissmiss: dissmiss,
        },
        {},
        "centro",
        true
      )(modalDispatch);
      // }
    } else {
      if (
        data !== null &&
        data !== undefined &&
        data.status === 400 &&
        data.data !== ""
      ) {
        let texto = data.data;
        showToaster(
          {
            texto: texto,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        hideModal()(modalDispatch);
        logoutPacienteDefault()(pacienteDispatch);
      } else if (
        data !== null &&
        data !== undefined &&
        data.status !== 400 &&
        data !== false
      ) {
        showToaster(
          {
            texto:
              "Su código no pudo ser verificado, contáctese con el centro de atención al paciente",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        hideModal()(modalDispatch);
        logoutPacienteDefault()(pacienteDispatch);
      }
    }
  };

  return (
    <>
      <div className="ptur-modal-password modalHeader bgcG-latex30">
        <h1 className="modalTitle rb18b c-white">
          Ingresá el Token de Seguridad
        </h1>
        <div className="cruz" onClick={dissmiss}>
          <div className="cruzParte1"></div>
          <div className="cruzParte2"></div>
        </div>
      </div>
      <div className="modalBody">
        <h3 className="ptur-modal-texto rb16t c-latex10">
          Ingresá el <span className="rb16m">token de seguridad</span> que le ha
          llegado a su casilla de mail. Debería de recibir en instantes dicho
          mail.
        </h3>
        <h3 className="rb16t c-latex10">{texto === "" ? "" : texto}</h3>
        <div className="ptur-modal-input">
          <InputV1
            name="codigoSeguridad"
            headerStr="Escriba su token de seguridad"
            placeholderText="H92KIYG"
            inputType="text"
            onChange={onCodigoChange}
            errorStr="El código es inválido"
            className="rb16m"
            maxLength="6"
            value={codigo}
            checkError={error}
            isRequired={true}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            className={`ptur-btnCodigoSeguridad rb16m c-latex30 ${
              disable ? "ptur-btnCodigoSeguridad-disabled" : "pointer"
            }`}
            onClick={() => reenviarEmail()}
            disabled={disable}
          >
            {disable ? (
              <Temporizador onChange={onChangeTemporizador} />
            ) : (
              "Reenviar mail"
            )}
          </button>
          <button
            className="ptur-btnCodigoSeguridad cursor:pointer c-white enviar rb18m"
            onClick={() => checkCodigo()}
          >
            {pacienteState.paciente.loading ? (
              <IonSpinner name="lines-small" />
            ) : (
              "Valida token"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default CambioPasswordPaso2;
